import apiRequest from '../apis/api-request';
import { selectAuthToken } from '../redux/reducers/authReducers';
import { store } from '../redux/store';

const questionService = {
    questionCreate: async (data) => {
        const token = selectAuthToken(store.getState());
        return apiRequest({
            method: "POST",
            url: `/api/question`,
            data: data,
            headers: {
                Authorization: "Bearer " + token
            },
        });
    },    
    questionUpdate: async (data) => {
        const token = selectAuthToken(store.getState());
        return apiRequest({
            method: "PUT",
            url: `/api/question/update`,
            data: data,
            headers: {
                Authorization: "Bearer " + token
            },
        });
    },
    questionList: async (data) => {
        const token = selectAuthToken(store.getState());
        return apiRequest({
            method: "GET",
            url: `/api/question/list/${data.chapter_id}`,
            headers: {
                Authorization: "Bearer " + token
            },
        });
    },    
    questionView: async (id) => {
        const token = selectAuthToken(store.getState());
        return apiRequest({
            method: "GET",
            url: `/api/question/${id}`,
            headers: {
                Authorization: "Bearer " + token
            },
        });
    },
    questionListInspection: async (data) => {
        const token = selectAuthToken(store.getState());
        return apiRequest({
            method: "GET",
            url: `/api/question/alllist/${data.chapter}/${data.inspection}?user_id=${data.user}`,
            headers: {
                Authorization: "Bearer " + token
            },
        });
    },
    questionViewInspection: async (data) => {
        const token = selectAuthToken(store.getState());
        return apiRequest({
            method: "GET",
            url: `/api/question/view/${data.id}/${data.inspection}`,
            headers: {
                Authorization: "Bearer " + token
            },
        });
    },
    questionChapterWiseList: async (data) => {
        const token = selectAuthToken(store.getState());
        return apiRequest({
            method: "GET",
            url: `/api/question/chapterwise/list/${data.vessel}/${data.chapter}`,
            headers: {
                Authorization: "Bearer " + token
            },
        });
    },
    getVesselWiseQuestions: async (data) => {
        return apiRequest({
            method: "GET",
            url: `/api/question/vessel_wise_questions/${data.inspection_id}`,
        });
    },
    excludeQuestion: async (data) => {
        return apiRequest({
            method: "PUT",
            url: `/api/question/exclude/question`,
            data
        });
    },
};

export default questionService;